<template>
  <div class="paint-detail">
    <div class="chart-box">
      <h4>{{ $ml.get("content").chart_year_title }}</h4>
      <div class="subtitle">{{ $ml.get("content").chart_year_subtitle }}</div>
      <ChartYears />
    </div>
    <div class="chart-box">
      <h4>{{ $ml.get("content").chart_dimension_title }}</h4>
      <div class="subtitle">
        {{ $ml.get("content").chart_dimension_subtitle }}
      </div>
      <ChartDimensions />
    </div>
  </div>
</template>

<script>
import ChartYears from "@/components/ChartYears.vue";
import ChartDimensions from "@/components/ChartDimensions.vue";
export default {
  name: "paint-detail",
  components: {
    ChartYears,
    ChartDimensions
  }
};
</script>

<style lang="scss" scoped>
.paint-detail {
  width: 100%;
  max-width: $max-width;
  margin: 0 auto;
  padding: 0 40px;
  .chart-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    h4 {
      margin: 0;
      @include h4-desktop-center;
    }
    .subtitle {
      opacity: 0.6;
      margin-bottom: 10px;
      @include subtitle-primarydesktop;
    }
    &:first-of-type {
      margin-bottom: 43px;
      @media (max-height: 600px) {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
